// remove 1 from did user/pass to make it work

export const environment = {
  name: 'dev',
  production: false,
  apiUrl: 'https://meteredgpt.accentureanalytics.com/api/',
  username: 'otsuka-api-user',
  password: 'w5;Z_/GD3Y*-bfkKS8B7~U',
  tenant: 'f3211d0e-125b-42c3-86db-322b19a65a22',
  clientId: '091b6f0f-ebe7-4ff9-803d-43b232a2ac86',
  // redirectUri: 'http://localhost:4200/',
  redirectUri: 'https://meteredgpt.accentureanalytics.com/',
  resource: 'api://62f592ce-ca4c-4be5-86d5-baf8e08a089c/user_impersonation',
};
